import script from "./LeadershipCards.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadershipCards.vue?vue&type=script&setup=true&lang=js"

import "./LeadershipCards.vue?vue&type=style&index=0&id=86897ae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86897ae8"]])

export default __exports__